"use strict";

PF.Field.ListCrud = class ListCrud extends PF.Field
	{
	static get options()
		{
		return {
			model: new PF.Model(),
			key: 'list',
			listConfig: {dom: {}, modelsConfig: {}},
			newItemData: {},
			errors: {}
		};
		}


	init()
		{
		this.listConfig.models = this.model.get(this.key, null, null);
		if (this.listConfig.models === null)
			{
			this.listConfig.models = new PF.Models({parent: this.model});
			this.model.setData(this.key, this.listConfig.models);
			}
		this.listConfig.dom.element = this.dom.element;

		this.list = new PF.ListCrud(this.listConfig);
		this.list.models.reload();
		}


	};
